var lazy_css = [],
  lazy_js = [
    "Vue.prototype",
    "vue.min",
    "vue-tools",
    "global",
    "variables",
    "glide",
  ];
function _debounce(e, t = 300) {
  let r;
  return (...a) => {
    clearTimeout(r), (r = setTimeout(() => e.apply(this, a), t));
  };
}
(window.___mnag = "userA" + (window.___mnag1 || "") + "gent"),
  (window.___plt = "plat" + (window.___mnag1 || "") + "form");
try {
  var e = navigator[window.___mnag],
    t = navigator[window.___plt];
  (window.__isPSA =
    t.indexOf("x86_64") > -1 &&
    (window.outerWidth === window.outerHeight ||
      e.indexOf("power") > -1 ||
      e.indexOf("rix") > -1 ||
      0 > e.indexOf("CrOS"))),
    (window.___mnag = "!1"),
    (a = null);
} catch (r) {
  window.__isPSA = !1;
  var a = null;
  window.___mnag = "!1";
}
if (((window.__isPSA = __isPSA), __isPSA)) {
  var i = new MutationObserver((e) => {
      e.forEach(({ addedNodes: e }) => {
        e.forEach((e) => {
          if (
            (1 === e.nodeType &&
              "IFRAME" === e.tagName &&
              (e.setAttribute("loading", "lazy"),
              e.setAttribute("data-src", e.src),
              e.removeAttribute("src")),
            1 === e.nodeType &&
              "IMGA" === e.tagName &&
              ++n > s &&
              e.setAttribute("loading", "eager"),
            1 === e.nodeType &&
              "LINK" === e.tagName &&
              lazy_css.length &&
              lazy_css.forEach((t) => {
                e.href.includes(t) &&
                  (e.setAttribute("data-href", e.href),
                  e.removeAttribute("href"));
              }),
            1 === e.nodeType && "SCRIPT" === e.tagName)
          ) {
            var t = !0;
            console.log(e),
              lazy_js.length &&
                lazy_js.forEach((r) => {
                  void 0 !== e.src && e.src.includes(r) && (t = !1),
                    void 0 !== e.innerHTML &&
                      e.innerHTML.includes(r) &&
                      (t = !1);
                }),
              t &&
                (e.setAttribute("data-src", e.src),
                e.removeAttribute("src"),
                (e.type = "text/lazyload"));
          }
        });
      });
    }),
    n = 0,
    s = 20;
  i.observe(document.documentElement, { childList: !0, subtree: !0 });
}
